import { render, staticRenderFns } from "./OrderableItemImport.vue?vue&type=template&id=13b35f40&"
import script from "./OrderableItemImport.vue?vue&type=script&lang=ts&"
export * from "./OrderableItemImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports